import { forwardRef, useEffect } from 'react';
import { TemplateEmailForNDBModal } from './TemplateEmailForNDBModal';
import { ModalDefaultProps } from 'components/Modal';
import { LocalStorageKeys } from 'helpers/localStorage';

import confirmImg from 'assets/images/modals/NDB/modal-image-email.webp';

export const ConfirmEmailForNDBModal = forwardRef<
  HTMLDivElement,
  ModalDefaultProps
>(({ onClose }, ref) => {
  useEffect(() => {
    localStorage.setItem(LocalStorageKeys.ConfirmEmailNDB, 'true');
  }, []);

  return (
    <TemplateEmailForNDBModal img={confirmImg} onClose={onClose} ref={ref} />
  );
});
